import { SVGAttributes } from 'react';

export default function CloseIcon(
  props: Omit<SVGAttributes<SVGSVGElement>, 'width' | 'height'> & {
    width: number;
    height: number;
  },
) {
  const {
    width,
    height,
    className,
    strokeWidth = 1.5,
    strokeLinecap = 'round',
    strokeLinejoin = 'round',
    ...rest
  } = props;

  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d={`M${width * 0.75} ${height * 0.25} L${width * 0.25} ${height * 0.75}`}
        stroke="currentColor"
        strokeWidth={strokeWidth}
        strokeLinecap={strokeLinecap}
        strokeLinejoin={strokeLinejoin}
      />
      <path
        d={`M${width * 0.25} ${height * 0.25} L${width * 0.75} ${height * 0.75}`}
        stroke="currentColor"
        strokeWidth={strokeWidth}
        strokeLinecap={strokeLinecap}
        strokeLinejoin={strokeLinejoin}
      />
    </svg>
  );
}
